import type { ConnectedSource, FileNode } from '@/tools/exmarked/types'
import { isLocalSource }                  from '@/tools/exmarked/types'
import { githubProvider }                 from './github'
import { localProvider }                  from './local'

// ─── Interface ────────────────────────────────────────────────────────────────

export interface SourceProvider {
  /** Walk the source and return every .md / .mdx file. */
  listFiles(source: ConnectedSource): Promise<{ files: FileNode[]; truncated: boolean }>
  /** Return the raw Markdown string for a single file. */
  readFile(source: ConnectedSource, file: FileNode): Promise<string>
}

// ─── Dispatcher ───────────────────────────────────────────────────────────────

export function getProvider(source: ConnectedSource): SourceProvider {
  return isLocalSource(source) ? localProvider : githubProvider
}
